<template>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-5" v-if="tranche.details && tranche.details.summary">
        <k-panel v-if="tranche.details.summary.dealOverview" class="border">
            <template v-slot:header>
                <k-panel-header>
                    Deal overview
                </k-panel-header>
            </template>
            <p class="leading-7" style="white-space: pre-line;">{{ tranche.details.summary.dealOverview }}</p>
        </k-panel>
        <k-panel v-if="tranche.details.summary.marketsAndProducts" class="border">
            <template v-slot:header>
                <k-panel-header>
                    Markets and products
                </k-panel-header>
            </template>
            <p class="leading-7" style="white-space: pre-line;">{{ tranche.details.summary.marketsAndProducts }}</p>
        </k-panel>
        <k-panel v-if="tranche.details.summary.dealStructure" class="border">
            <template v-slot:header>
                <k-panel-header>
                    Deal structure
                </k-panel-header>
            </template>
            <p class="leading-7" style="white-space: pre-line;">{{ tranche.details.summary.dealStructure }}</p>
        </k-panel>
    </div>
</template>

<script>
export default {
    props: {
        tranche: {
            type: Object,
            default: () => ({})
        }
    }
}
</script>
